import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';

export function useResendHcpActivation() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, number>({
        mutationFn: async (healthcareProfessionalId: number) =>
            HealthcareProfessionalsApi.resendActivation(healthcareProfessionalId.toString()),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionals] });
            notifications.show({ message: t('hcp.resendActivationSent'), color: 'green' });
        },
    });
}
